export const isEmpty = (value: string | undefined | null) =>
  value === undefined || value === null || value === '' || value.length === 0;

/**
 * To check whether the value is falsy or truthy.
 * @param {string} value
 * @returns {string}
 */
export function required(value: string) {
  if (value && typeof value === 'string') {
    value = value.trim();
  }
  if (isEmpty(value)) {
    return 'Please enter ';
  }
}

/**
 * To check whether email is valid or not
 * @param email email string
 */
export function validateEmail(email: string) {
  if (!email) {
    return '';
  }
  const regex = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
  return regex.test(email) ? '' : 'Please enter a valid ';
}

export function validatePassword(password: string) {
  const hasAlphabet = /[a-z]+/.test(password);
  const hasNumber = /[0-9]+/.test(password);
  const hasSpecialCharacter = /[!#$%&()*+\-,./:;<=>?@[\]^_`"{|}~'\\]+/.test(password);
  const hasCapitalLetter = /[A-Z]+/.test(password);
  const hasInvalidSpecialCharacter = /[^a-zA-Z0-9!#$%&()*+\-,./:;<=>?@[\]^_`"{|}~'\\]+/.test(password);

  if (!hasAlphabet || !hasNumber || !hasSpecialCharacter || !hasCapitalLetter) {
    return 'Please enter a valid password';
  }

  if (hasInvalidSpecialCharacter) {
    return 'Only these special characters are allowed: [" ! # $ % & ( ) * + , - . / \\ : ; < = > ? @ [ ] ^ _ ` { | } ~]';
  }

  return '';
}

/**
 * Composes all the validators into single function
 * @param validators
 * @returns
 */
export function composeValidators(...validators: any) {
  return (value: string, allValues: object) =>
    validators.reduce(
      (error: string, validator: any) => error || validator(value, allValues),
      undefined
    );
}

/**
 * Validates the minimum length of characters to enter.
 * @param min Text to verify minimum length
 */
export function minLength(min: number, suffixNeeded: boolean = false) {
  return (value: any) => {
    if (value && value.length < min) {
      return `Please enter a valid ${suffixNeeded ? 'password' : ''} `;
    }
  };
}

/**
 * Validates the maxixmum length of characters to enter.
 * @param max Text to verify maximum length
 */
export function maxLength(max: number, suffixNeeded: boolean = false) {
  return (value: string) => {
    if (value && value.length > max) {
      return `Please enter a valid ${suffixNeeded ? 'password' : ''} `;
    }
  };
}

/**
 * Removes all characters except numerics in the given string
 * @param value
 * @returns {string}
 */
export function convertToNumber(value: string): string {
  if (value) {
    value = value.replace(/[^\d]/g, '');
    return value;
  } else {
    return value;
  }
}
